import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../Hooks/useAuth';
import { hasCapability } from './Shared/AuthCapabilityHelper';

export interface CapabilityGuardedRouteProps {
    capability: string;
    children: React.ReactElement;
}

const CapabilityGuardedRoute = ({ capability, children }: CapabilityGuardedRouteProps) => {
    const { user } = useAuth();

    if (!hasCapability(user, capability)) {
        return <Navigate to="/home" replace />;
    }

    return children;
};

export default CapabilityGuardedRoute;
